import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { SubscriptionService } from 'src/app/shared/services/subscription.service';
import { Subscription } from 'rxjs';
import { displayErrorMessage } from 'src/app/theme/utils/util-functions';
import { MatProgressButtonOptions } from 'mat-progress-buttons';

@Component({
  selector: 'app-edit-credit-card',
  templateUrl: './edit-credit-card.component.html',
  styleUrls: ['./edit-credit-card.component.scss']
})
export class EditCreditCardComponent implements OnInit, OnDestroy {
  
  creditCardForm: FormGroup;
  userDetails: object;
  userAddress: object;
  creditCardDetails: object;

  unSubscription: Array<Subscription> = [];
  editButtonOptions: MatProgressButtonOptions = {
    active: false,
    text: 'Update',
    buttonColor: 'primary',
    spinnerSize: 18,
    raised: true,
    stroked: false,
    fullWidth: false,
    disabled: false,
    mode: 'indeterminate',
  }
  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private notification: NotificationService,
    private subscription: SubscriptionService
  ) { }

  ngOnInit() {

    /*********get user details in resolver*********/
    let resolverUserDetails = this.route.snapshot.data.userDetails;
    if(resolverUserDetails['response']['status'] === 1) {
      let data = resolverUserDetails['response']['data']['users'];
      this.userDetails = data;
      this.userAddress = {
        // first_name: data.first_name,
        // last_name: data.last_name,
        address: data.address,
        city: data.city,
        state: data.state,
        zipcode: data.zipcode
      }
    }
    /**********************END********************/

    /*********get credit card data in behaviorsubject*********/
    const getCreditCardSubscription = this.subscription.getBehSubject().subscribe(data => {
      if(!!data['msg'] && data['msg'] === 'Edit Credit Card') {
        this.creditCardDetails = data['creditCard'];
      }
    });
    this.unSubscription.push(getCreditCardSubscription);
    /****************************END**************************/

    this.creditCardForm = this.formBuilder.group({
      id: ['', [Validators.required]],
      // first_name: ['', [Validators.required, Validators.maxLength(35)]],
      // last_name: ['', [Validators.required, Validators.maxLength(35)]],
      address: ['', [Validators.required, Validators.maxLength(60)]],
      city: ['', [Validators.required]],
      state: ['', [Validators.required]],
      zipcode: ['', [Validators.required]]
    });

    if(!!this.creditCardDetails) {
      if(!(!!this.creditCardDetails['billing_address'])) {
        this.creditCardDetails['billing_address'] = this.userAddress;
      }
      this.creditCardDetails['billing_address'] = {
        ...this.creditCardDetails['billing_address'],
        id: this.creditCardDetails['id']
      };
      this.creditCardForm.patchValue({...this.creditCardDetails['billing_address']});
    }else {
      this.notification.warning("Please choose a credit card!", 5000);
      this.router.navigate(['/account/payment']);
    }

  }

  updateCreditCard() {
    if(this.creditCardForm.valid) {
      this.editButtonOptions.active = true;
      let params = this.creditCardForm.value;
      this.apiService.updateCreditCard(params).subscribe(data => {
        this.editButtonOptions.active = false;
        if(data['response']['status'] === 0) {
          this.notification.error(data['response'].message, 5000)
        }else if(data['response']['status'] === 1) {
          this.notification.success('Credit card successfully updated', 5000);
          this.router.navigate(['/account/payment']);
        }else if(data['response'].status === 2 || data['response'].status === 3) {
          displayErrorMessage({
            notification: this.notification, 
            response: data['response'], 
            formControl: this.creditCardForm.controls
          });
        }else if(data['response'].status === 4) {
          this.notification.error(data['response'].message, 5000);
        }else if(data['response'].status === 6) {
          this.notification.error(data['response'].message, 5000);
        }
      }, err => {
        this.editButtonOptions.active = false;
        console.log(err);
      })
    }
  }

  ngOnDestroy() {
    this.unSubscription.forEach(subscription => {
      subscription.unsubscribe();
    });
  }

}
